<div class="d-flex flex-column min-vh-100">
  <app-header class="w-100 px-3 mt-3 mb-5 container mx-auto"></app-header>
  <main class="flex-grow-1 w-100 container pt-0 pb-5 px-3 mx-auto">
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
